import { createRouter, createWebHashHistory } from "vue-router";
import HomePage from "@/views/HomePage.vue";
// import PanelPage from '@/views/PanelPage.vue'
import NotificationsPage from "@/views/NotificationsPage.vue";
import BroadcastMessagesPage from "@/views/adm/BroadcastMessagesPage.vue";
import NewBroadcastMessagesPage from "@/views/adm/NewBroadcastMessagePage.vue";
import MyBillingHistoryPage from "@/views/user/MyBillingHistoryPage.vue";
import MyPersonalDataPage from "@/views/user/MyPersonalDataPage.vue";
import ChangeMyPasswordPage from "@/views/user/ChangeMyPasswordPage.vue";
import CancelSubscriptionPage from "@/views/user/CancelSubscriptionPage.vue";
import LoginPage from "@/views/auth/LoginPage.vue";
import RegisterStep1Page from "@/views/auth/RegisterStep1Page.vue";
import RegisterStep2Page from "@/views/auth/RegisterStep2Page.vue";
import ForgetPasswordPage from "@/views/auth/ForgetPasswordPage.vue";
import RegisterSuccessPage from "@/views/auth/RegisterSuccessPage.vue";
import QuickRegisterStep1Page from "@/views/auth/QuickRegister/QuickRegisterStep1Page.vue";
import QuickRegisterStep2Page from "@/views/auth/QuickRegister/QuickRegisterStep2Page.vue";
import QuickRegisterSuccessPage from "@/views/auth/QuickRegister/QuickRegisterSuccessPage.vue";
import { useAuthStore } from "@/stores/auth";
import pinia from "@/libs/pinia";
import LogoutPage from "@/views/auth/LogoutPage.vue";
import SubscriptionsPage from "@/views/user/SubscriptionsPage.vue";
import NewSubscriptionPage from "@/views/user/NewSubscription/NewSubscriptionPage.vue";
import UsersPage from "@/views/adm/UsersPage.vue";
import EditUserPage from "@/views/adm/EditUserPage.vue";
import TermsOfUsePage from "@/views/legal/TermsOfUsePage.vue";
import PrivacyPolicyPage from "@/views/legal/PrivacyPolicyPage.vue";
import RequestAccountDeletionPage from "@/views/legal/RequestAccountDeletionPage.vue";
import AccountDeletionRequestsPage from "@/views/adm/AccountDeletionRequestsPage.vue";

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes: [
    { path: "/", name: "Home", component: HomePage },
    // { path: '/adm/panel', name: 'Panel', component: PanelPage},
    {
      path: "/notifications",
      name: "Notifications",
      component: NotificationsPage,
    },
    { path: "/adm/users", name: "Users", component: UsersPage },
    { path: "/adm/users/:id", name: "EditUser", component: EditUserPage },
    {
      path: "/adm/broadcast-messages",
      name: "BroadcastMessagesPage",
      component: BroadcastMessagesPage,
    },
    {
      path: "/adm/new-broadcast-message",
      name: "NewBroadcastMessagesPage",
      component: NewBroadcastMessagesPage,
    },
    {
      path: "/user/change-password",
      name: "ChangeMyPassword",
      component: ChangeMyPasswordPage,
    },
    {
      path: "/user/my-billing-history",
      name: "MyBillingHistory",
      component: MyBillingHistoryPage,
    },
    {
      path: "/user/cancel-subscription",
      name: "CancelSubscription",
      component: CancelSubscriptionPage,
    },
    {
      path: "/user/my-personal-data",
      name: "MyPersonalData",
      component: MyPersonalDataPage,
    },
    {
      path: "/user/subscriptions",
      name: "Subscriptions",
      component: SubscriptionsPage,
    },
    {
      path: "/user/new-subscription",
      name: "NewSubscription",
      component: NewSubscriptionPage,
    },
    { path: "/auth/login", name: "AuthLogin", component: LoginPage },
    { path: "/auth/logout", name: "AuthLogout", component: LogoutPage },
    {
      path: "/auth/mobile-register",
      name: "AuthRegister",
      component: RegisterStep1Page,
    },
    {
      path: "/auth/mobile-register/step-2",
      name: "AuthRegisterStep2",
      component: RegisterStep2Page,
    },
    {
      path: "/auth/forget-password",
      name: "AuthForgetPassword",
      component: ForgetPasswordPage,
    },
    {
      path: "/auth/mobile-register/success",
      name: "AuthRegisterSuccess",
      component: RegisterSuccessPage,
    },
    {
      path: "/auth/register",
      name: "QuickRegisterStep1",
      component: QuickRegisterStep1Page,
    },
    {
      path: "/auth/register/finalize",
      name: "QuickRegisterStep2",
      component: QuickRegisterStep2Page,
    },
    {
      path: "/auth/register/success",
      name: "QuickRegisterSuccess",
      component: QuickRegisterSuccessPage,
    },
    {
      path: "/legal/termos-de-uso",
      name: "TermsOfUse",
      component: TermsOfUsePage,
    },
    {
      path: "/legal/politicas-de-privacidade",
      name: "PrivacyPolicy",
      component: PrivacyPolicyPage,
    },
    {
      path: "/request-account-deletion",
      name: "RequestAccountDeletion",
      component: RequestAccountDeletionPage,
    },
    {
      path: "/adm/account-deletion-requests",
      name: "AccountDeletionRequests",
      component: AccountDeletionRequestsPage,
    },
  ],
});

const authStore = useAuthStore(pinia);
const publicPages = [
  "/auth/login",
  "/auth/register",
  "/auth/register/finalize",
  "/auth/logout",
  "/auth/forgot-password",
  "/auth/register/success",
  "/auth/mobile-register",
  "/auth/mobile-register/step-2",
  "/auth/mobile-register/success",
  "/legal/termos-de-uso",
  "/legal/politicas-de-privacidade",
  "/request-account-deletion",
];
router.beforeEach((to) => {
  const authRequired = !publicPages.includes(to.path);
  const adminRequired = to.path.startsWith("/adm/");
  if (authRequired && !authStore.isLoggedIn) {
    return "/auth/login";
  } else if (adminRequired && !authStore.isAdmin) {
    return "/auth/login";
  }
});

export default router;
